export function strToRegExp(str: string) {
	return `/^(.*?(${str
		.replace(/[.*+?^${}()_\-@|[\]\\]/g, '\\$&')
		.split(' ')
		.filter(Boolean)
		.join('|')})[^$]*)$/i`
}
